import { site } from "../content/site";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

export const HowItWorks = () => (
  <section id="how-it-works" className="border-t border-gray-200 bg-gray-50" data-testid="how-it-works-section">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
      <SectionHeader
        eyebrow={site.howItWorks.eyebrow}
        heading={site.howItWorks.heading}
        testid="how-it-works-heading"
      />
      <ol className="mt-14 grid grid-cols-1 gap-x-10 gap-y-12 md:grid-cols-3">
        {site.howItWorks.steps.map((step, i) => (
          <Reveal as="li" key={step.number} delay={i * 0.1} className="border-t border-gray-300 pt-6">
            <span className="font-heading text-4xl font-extrabold tracking-tight text-brand" aria-hidden="true">
              {step.number.padStart(2, "0")}
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-gray-900">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-600">{step.text}</p>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
